import { render, staticRenderFns } from "./UserPackets.vue?vue&type=template&id=2c68a147&scoped=true&"
import script from "./UserPackets.vue?vue&type=script&lang=js&"
export * from "./UserPackets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68a147",
  null
  
)

export default component.exports